import React from 'react';
import PropTypes from 'prop-types';
import { Arrow, Error404 } from '../../../../assets/images';
import {
  StyledErrorWrapper,
  StyledErrorContent,
  StyledTitle,
  StyledErrorNumber,
  StyledText,
  StyledLink,
  StyledErrorUlLinks,
  StyledErrorImage,
  StyledIcon
} from './style';

/** Models */
import { dataErrorNumberModel } from '../../../utils/models';

const ErrorNumber = ({ className, data }) => (
  <StyledErrorWrapper className={className}>
    <StyledErrorContent>
      <StyledTitle>{data.type}</StyledTitle>
      <StyledErrorNumber>{data.number}</StyledErrorNumber>
      <StyledText>{data.description}</StyledText>
      <StyledErrorUlLinks>
        {data.actions.map(item => (
          <li key={item.texto}>
            <StyledLink to={item.link}>
              {item.text} <StyledIcon svg={Arrow} />{' '}
            </StyledLink>
          </li>
        ))}
      </StyledErrorUlLinks>
    </StyledErrorContent>
    <StyledErrorImage>
      <StyledIcon svg={Error404} />
    </StyledErrorImage>
  </StyledErrorWrapper>
);

ErrorNumber.propTypes = {
  className: PropTypes.string,
  data: dataErrorNumberModel
};

ErrorNumber.defaultProps = {
  className: undefined,
  data: {
    type: 'Error',
    number: '404',
    description: '',
    actions: []
  }
};

export default ErrorNumber;
